export const routerPaths = {
  LOGIN: "login",
  SIGNUP: "signup",

  VOICE_BROADCASTS: "voice-broadcasts",
  CONTACTS: "contacts",
  SERVERS: "servers",
  TRUNKS: "trunks",
  MY_ACCOUNT: "my-account",
  MY_FILES: "my-files",
  SUPPORT: "support",
  ACCESS_TOKEN: "access-token",
  PARTNERS: "partners",
  BROAD_NUMBER: "voice-broadcast-numbers",
  PBX_CALL_DETAIL: "pbx-call-detail-records",
  FORGET_PASSWORD: "forget-password",
  WALLET: "wallet",
  WALLET_TRANSACTION: "wallet-transactions",
  USERS: "users",
  ROLES: "roles",
  ACCESS: "access-manage",
  RECEIPTS: "receipts",
  PAYMENTS: "payments",
  WORKSPACES: "workspaces",
  SETTINGS: "settings",
  RECEIPT: "receipt",
  TRANSFER: "transfer",
  SECURE_CALLS: "secure-calls",
  LOGS: "logs",
  OTP_CALLS: "otp-calls",
  REPORT:"report",
  BLOCK_NUMBERS:"block-numbers",
  SEND_CALLS:"send-calls",
  DASHBOARD: "/",
};

export const accessPaths = {
  "/voice-broadcasts": "admin.voice_broadcasts.list",
  "/servers": "admin.pbx_servers.list",
  "/trunks": "admin.pbx_trunks.list",
  "/my-account": "",
  "/my-files": "admin.files.list",
  "/support": "admin.tickets.list",
  "/access-token": "admin.access_tokens.list",
  "/partners": "admin.partner.list",
  "/voice-broadcast-numbers": "admin.voice_broadcast_numbers.list",
  "/pbx-call-detail-records": "admin.pbx_call_detail_records.list",
  "/wallet": "admin.wallets.list",
  "/wallet-transactions": "admin.transactions.list",
  "/users": "admin.users.list",
  "/roles": "admin.acl_roles.list",
  "/access-manage": "admin.acl_sections.list",
  "/receipts": "admin.payment_receipts.list",
  "/payments": "admin.payment_gateway.list",
  "/workspaces": "admin.workspaces.list",
  "/settings": "",
  "/receipt": "",
  "/transfer": "",
  "/forget-password": "",
  "/contacts": "",

  "/voice-broadcasts-detail": "admin.voice_broadcast_numbers.list",
  "/servers-detail": "admin.pbx_servers.details",
  "/trunks-detail": "admin.pbx_trunks.details",
  "/support-detail": "admin.tickets.details",
  "/receipt-detail": "admin.tickets.details",
};

export enum accessPathsEnums {
  "voice_broadcasts_list" = "admin.voice_broadcasts.list",
  "pbx_servers_list" = "admin.pbx_servers.list",
  "pbx_trunks_list" = "admin.pbx_trunks.list",
  "files_list" = "admin.files.list",
  "tickets_list" = "admin.tickets.list",
  "access_tokens_list" = "admin.access_tokens.list",
  "partner_list" = "admin.partner.list",
  "voice_broadcast_numbers_list" = "admin.voice_broadcast_numbers.list",
  "pbx_call_detail_records_list" = "admin.pbx_call_detail_records.list",
  "wallets_list" = "admin.wallets.list",
  "transactions_list" = "admin.transactions.list",
  "users_list" = "admin.users.list",
  "acl_roles_list" = "admin.acl_roles.list",
  "acl_sections_list" = "admin.acl_sections.list",
  "payment_receipts_list" = "admin.payment_receipts.list",
  "payment_gateway_list" = "admin.payment_gateway.list",
  "workspaces_list" = "admin.workspaces.list",
  "pbx_servers_details" = "admin.pbx_servers.details",
  "pbx_trunks_detail" = "admin.pbx_trunks.details",
  "tickets_details" = "admin.tickets.details",
  "logs_list" = "admin.logs.list",
  "logs_details" = "admin.logs.details",
  "secure_calls_list" = "admin.secure_calls.list",
  "otp_calls_list" = "admin.otp_calls.list",
  "reports_call_queue_sender" = "admin.reports.call_queue_sender",
  "partner_reset_status" = "admin.partner.reset_status",
  "partner_details" = "admin.partner.details",
  "admin_send_calls_list" = "admin.send_calls.list",
  "admin_block_numbers_list" = "admin.block_numbers.list",
  "admin_block_numbers_create" = "admin.block_numbers.create",
  "admin_block_numbers_update" = "admin.block_numbers.update",
  "admin_block_numbers_delete" = "admin.block_numbers.delete"
}
